import { render, staticRenderFns } from "./ShoppingCartTable.vue?vue&type=template&id=2aa9d41a&scoped=true&"
import script from "./ShoppingCartTable.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartTable.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartTable.vue?vue&type=style&index=0&id=2aa9d41a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa9d41a",
  null
  
)

export default component.exports